import { cn } from "@/lib/utils";
import Image from "next/image";

export const ProfileCard: React.FC<{
  profile: {
    name: string;
    position: string;
    image?: string;
    mobileImage?: string;
    nameBackgroundColor?: string;
    nameTextColor?: string;
    designationTextColor?: string;
  };
  index: number;
  isActive?: boolean;
}> = ({ profile, index, isActive = false }) => {
  const imageSrc =
    profile.image || profile.mobileImage || "/images/placeholder.png";

  return (
    <div
      className={cn(
        "flex flex-col items-start w-full shrink-0 group cursor-pointer ",
        isActive ? "opacity-100" : "grayscale-100",
      )}
      style={
        {
          // @ts-ignore
          "--profile-bg-color": profile.nameBackgroundColor || "#F74958",
          "--profile-text-color": profile.nameTextColor || "#FFFFFF",
          "--designation-text-color": profile.designationTextColor || "#FFFFFF",
        } as React.CSSProperties
      }
    >
      {imageSrc && (
        <div
          className={cn(
            "relative w-full shadow-xl shrink-0 overflow-hidden",
            "h-[200px]",
            "sm:h-[206px]",
            "lg:h-[220px]",
            "xl:h-[280px]",
          )}
        >
          <Image
            src={imageSrc}
            alt={profile.name}
            width={1000}
            height={1000}
            className="absolute inset-0 w-full h-full object-contain"
          />
        </div>
      )}

      {isActive && (
        <div
          className={cn(
            "w-full flex flex-col items-start justify-center px-4 py-1 h-[108px]",
            "sm:h-[92px]",
            "md:h-[98px]",
            "lg:h-[128px]",
          )}
          style={{ backgroundColor: "var(--profile-bg-color)" }}
        >
          <p
            className={cn(
              "text-heading-7-bold",
              "sm:text-heading-9-bold",
              "md:text-body-2-semibold",
              "lg:text-new-body-24-semibold",
              "line-clamp-2 text-start",
              "type-h5",
            )}
            style={{ color: "var(--profile-text-color)" }}
          >
            {profile.name}
          </p>
          <p
            className={cn(
              "text-body-3-regular",
              "sm:text-body-3-regular",
              "md:text-heading-9-regular",
              "lg:text-label-5-regular",
              "xl:text-body-1-regular",
              "line-clamp-2 text-start",
              "type-body-sm",
            )}
            style={{ color: "var(--designation-text-color)" }}
          >
            {profile.position}
          </p>
        </div>
      )}
    </div>
  );
};
